<template>
  <div>
    <div class="intros">
      <div class="showinfor">
        <span>{{pagerParam.total}}{{$t('global.个成员')}}</span>
        <div class="rightside">
          <div class="defaultstate" v-show="!isEdit">
            <a @click="editBtn">{{$t('global.编辑')}}</a>
          </div>
          <div class="editstate" v-if="isEdit">
            <el-checkbox v-model="checked" @change="checkAll">{{$t('global.全选')}}</el-checkbox>
            <a @click="rankPost">{{$t('global.按序号排序')}}</a>
            <a @click="backBtn">{{$t('global.返回')}}</a>
          </div>
        </div>
      </div>

      <div class="memberinfor">
        <ul>
          <li class="userinforbox" v-for="item of createrList" :key="item.id">
            <img class="avatar" :src="item.avatar | imageUrl('/static/profile_img_default.png',152,152)" />
            <div class="usercontent">
              <p class="name">{{item.nickName}}</p>
              <p class="city">{{item.area}}</p>
              <p class="mavideo">
                <span>{{$t('global.粉丝')}}</span>
                <b>{{item.fansCount}}</b>
                <span>{{$t('global.视频')}}</span>
                <b>{{item.videoCount}}</b>
              </p>
            </div>
            <div class="checkarea" v-if="isEdit">
              <div
                class="checkedbox"
                @click="editSelect(selectCreater,item)"
                :class="{showbox:getSelect(selectCreater,item.id)}"
              ></div>
              <input type="text" v-model="item.rank" />
            </div>
            <div class="clearfix"></div>
            <div class="signature">{{item.signature}}</div>
          </li>
        </ul>
      </div>
    </div>

    <pages
      :page-size="pagerParam.pageSize"
      :page-count="pagerParam.pageCount"
      :current-page="pagerParam.currentPage"
      :total="pagerParam.total"
      @current-page-changed="OnCurrentPageChanged"
    ></pages>
  </div>
</template>

<script>
import pages from "@/components/pages.vue";
export default {
  name: "itemStep5",
  components: {
    pages
  },
  data() {
    return {
      createrList: [],
      selectCreater: [],
      rankList: [],

      isShow: false,

      pagerParam: {
        pageSize: 12,
        pageCount: 1,
        currentPage: 1,
        total: 1
      },
      isEdit: false,
      checked: false
    };
  },
  created() {
    this.topicId = this.$route.params.id;
    this.getCreaterList();
  },
  methods: {
    getCreaterList() {
      let params = {
        topicId: this.topicId,
        pageIndex: this.pagerParam.currentPage,
        pageSize: this.pagerParam.pageSize
      };
      let url = `/api/2.0/topic/creatersOrderNew`;

      this.$http.get(url, { params: params }).then(response => {
        if (response.code === "OK") {
          this.createrList = response.data.list;

          this.pagerParam = {
            pageSize: response.data.pageSize,
            pageCount: response.data.totalPage,
            currentPage: response.data.pageIndex,
            total: response.data.totalRecord
          };
        }
      });
    },
    editBtn() {
      this.isEdit = true;
      this.isShow = true;
    },
    backBtn() {
      this.isEdit = false;
      this.isShow = false;
      this.selectCreater = [];
    },
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.getCreaterList();
    },
    editSelect(list, editer) {
      let index = list.findIndex(item => item.userId === editer.id);
      if (index != -1) {
        list.splice(index, 1);
      } else {
        list.push({
          userId: editer.id,
          rank: editer.rank || ""
        });
      }
    },
    getSelect(list, id) {
      if (list.find(item => item.userId === id)) {
        return true;
      } else {
        return false;
      }
    },
    rankPost() {
      if (this.selectCreater != null && this.selectCreater.length > 0) {
        this.selectCreater = this.selectCreater.map(item => {
          const rank = this.createrList.find(it => it.id === item.userId).rank;
          return {
            ...item,
            rank: rank
          };
        });
        this.$http
          .post("/api/2.0/topic/creater/rank", {
            topicId: this.topicId,
            rankList: JSON.stringify(this.selectCreater)
          })
          .then(response => {
            if (response.code == "OK") {
              this.$message.success(this.$t("global.排序成功"));
            }
          });
      } else {
        this.$message.error(this.$t("global.请选中排序创作者"));
      }
    },

    checkAll(value) {
      this.checked = value;
      if (this.checked) {
        this.selectCreater = this.createrList.map(item => ({
          userId: item.id,
          rank: item.rank
        }));
      } else {
        this.selectCreater = [];
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.el-form {
  float: left;
  width: 994px;
  padding: 22px 13px 0 50px;
  background-color: #fff;
  box-sizing: border-box;
}

.intros {
  padding: 22px 50px 46px;
  overflow: hidden;
  background-color: #fff;
}

.showinfor {
  height: 30px;
  color: #999;
  line-height: 30px;
  font-size: 12px;
  overflow: hidden;
}

.showinfor > span {
  float: left;
}

.showinfor .rightside {
  float: right;
}

.showinfor .rightside a {
  display: inline-block;
  height: 30px;
  padding: 0 18px;
  color: #fff;
  border-radius: 2px;
  margin-left: 10px;
  cursor: pointer;
  background-color: rgba(0, 173, 239, 1);
}

.memberinfor {
  margin-top: 22px;
  overflow: hidden;

  ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    li.userinforbox {
      overflow: hidden;
      padding: 20px 0;
      border-bottom: 1px solid #edecf1;
      width: 400px;

      &>img {
        float: left;
        width: 76px;
        height: 76px;
        margin-right: 16px;
        border-radius: 50%;
      }

      .usercontent {
        float: left;
        width: 130px;
        color: #999;
        font-size: 12px;

        p {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .name {
          font-weight: bold;
          font-size: 16px;
          color: #333;
        }

        .city {
          margin: 7px 0;
          height: 20px;
          line-height: 20px;
        }

        .mavideo {
          b {
            color: #000;
            margin: 0 13px 0 6px;
          }
        }
      }

      .checkarea {
        margin-top: 25px;

        .checkedbox {
          display: inline-block;
          float: left;
          width: 20px;
          height: 20px;
          cursor: pointer;
          margin-right: 8px;
          background: url('/static/home/images/checked.png') no-repeat;
          background-size: 100% 100%;

          &.showbox {
            background: url('/static/home/images/ischecked.png') no-repeat;
            background-size: 100% 100%;
          }
        }

        input[type='text'] {
          width: 54px;
          text-align: right;
          padding-right: 5px;
          height: 20px;
          background: rgba(245, 245, 245, 1);
          border: 1px solid rgba(151, 151, 151, 1);
          box-sizing: border-box;
        }
      }
    }
  }
}

.signature {
  color: #999;
  padding-left: 92px;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}

.fixconent .hostactivity li {
  float: left;
  width: 50%;
  margin: 20px 0 0 0;
  border-bottom: 1px solid #edecf1;
  box-sizing: border-box;
}

.fixconent .hostactivity li:nth-child(2n) {
  padding: 0 0 20px 10px;
}

.fixconent .hostactivity li:nth-child(2n + 1) {
  padding: 0 10px 20px 0;
}

.fixconent .hostactivity li:nth-child(2) {
  margin-right: 0;
}

.fixconent .hostactivity li .city .checkedbox {
  float: right;
  margin-right: 0;
}

.fixconent .checkarea {
  display: block;
  top: 70px;
}

.fixconent .checkarea input {
  display: none;
}

.hostactivity ul {
  width: 100%;
}

.hostactivity li {
  position: relative;
  float: left;
  width: calc(((100% - 30px) / 2));
  margin: 24px 20px 20px 0;
  overflow: hidden;
}

.hostactivity li:nth-child(2n) {
  margin-right: 0;
}

.hostactivity li .hostac {
  width: 100%;
  height: 135px;
  border-radius: 5px;
}

.hostactivity li a {
  display: inline-block;
  overflow: hidden;
}

.hostactivity li span {
  font-size: 12px;
  color: #999;
}

.fixconent .hostactivity .avatar {
  float: left;
  width: 76px;
  height: 76px;
  margin-right: 16px;
  border-radius: 50%;
}

.addfixwindow {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.5;
  z-index: 999;
  background-color: #000;
}

.fixconent {
  position: fixed;
  width: 607px;
  height: 659px;
  top: 50%;
  left: 50%;
  z-index: 1000;
  transform: translate(-50%, -50%);
  background-color: #fff;
}

.fixconent > p {
  height: 50px;
  color: #000;
  font-size: 20px;
  font-weight: bold;
  padding: 0 26px;
  line-height: 50px;
  border-bottom: 1px solid #edecf1;
  box-sizing: border-box;
}

.headsearch {
  position: relative;
  padding: 0 26px;
  margin: 20px auto 0;
}

.headsearch input {
  width: 100%;
  height: 30px;
  border-radius: 5px;
  padding-left: 10px;
  background: rgba(245, 245, 245, 1);
  box-sizing: border-box;
}

.headsearch img {
  position: absolute;
  top: 5px;
  right: 36px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.fixconent .hostactivity {
  position: relative;
  padding: 0 30px;
  overflow: hidden;
  height: 500px;
  border-bottom: 1px solid #edecf1;
  box-sizing: border-box;
}

.fixconent .hostactivity li:nth-child(2n) {
  margin-right: 0;
}

.fixconent .hostactivity li .hostac {
  height: 95px;
}

.fixconent .hostactivity li p {
  font-size: 14px;
  width: calc(100% - 92px);
  margin-left: 92px;
  font-weight: bold;
  height: 19px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fixconent .hostactivity .usercontent p.city {
  margin: 7px 0 7px 92px;
  overflow: hidden;
}

.fixconent .hostactivity .usercontent p.city span {
  float: left;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fixconent .hostactivity .usercontent p.city .checkicon {
  float: right;
}

.fixconent .hostactivity .pages {
  position: absolute;
  margin: 0;
  left: 50%;
  bottom: 10px;
  transform: translate(-50%, 0);
}

.fixconent .underbutton {
  font-size: 12px;
  color: #999;
  height: 30px;
  padding: 0 30px;
  margin-top: 15px;
  line-height: 30px;
}

.fixconent .underbutton span {
  float: left;
}

.fixconent .underbutton a {
  float: right;
  display: inline-block;
  width: 64px;
  height: 30px;
  cursor: pointer;
  line-height: 30px;
  text-align: center;
  border-radius: 2px;
  box-sizing: border-box;
}

.fixconent .underbutton a.sure {
  color: #fff;
  margin-left: 13px;
  background: rgba(0, 173, 239, 1);
}

.fixconent .underbutton a.cancel {
  color: #999;
  border: 1px solid rgba(224, 224, 224, 1);
}

.fixconent .closepopus {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 17px;
  height: 17px;
  cursor: pointer;
}

input[type='radio'] {
  position: relative;
  top: 2px;
  margin: 0 10px;
}

.addsed {
  float: right;
  display: inline-block;
  width: 44px;
  height: 18px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
  background: rgba(0, 173, 239, 1);
  border-radius: 2px;
}

.underbutton em {
  font-style: normal;
}

.intros {
  border-top: 1px solid rgba(238, 238, 238, 1);
  box-sizing: border-box;
}
</style>





// WEBPACK FOOTER //
// src/pages/v2/subject/step/Step5.vue